import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { LOAD_API_SUCCESS, logError, beginLMSSession } from "../actions";
export default function onAPILoaded(action$, _state$) {
    return action$.pipe(ofType(LOAD_API_SUCCESS), switchMap(function() {
        return [
            beginLMSSession()
        ];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "on_api_loaded"
        }));
    }));
}
